export default __webpack_public_path__ + "static/media/activeArrowRightDark.f4beb478.svg";